import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';
import { FilterContentItem, FilterModalState, FilterModalType, isDateRangeFilterType } from './filterModal';
import { i18n } from '@/i18n';
import { FilterModalViewModel } from './filterModalViewModel';
import { simpleCopy } from '@/utils/deepCopy';

const t = i18n.t;
const vm = new FilterModalViewModel();

export const useFilterModalStore = defineStore('filterModal', () => {
  const state = reactive<FilterModalState>({
    filterItems: [],
    currentFilterType: undefined,
  });

  /**
   * リセット
   */
  const $reset = () => {
    state.filterItems = [];
    state.currentFilterType = undefined;
  };

  /**
   * 適用されたフィルターコンテンツ
   */
  const appliedFilterContent = computed((): FilterContentItem[] => {
    return state.filterItems.filter((item) => {
      if (item.filterType === 'LAST_CHECKED_AT') {
        return item.selectedValue.length > 0 || item.includeNull;
      }
      if (isDateRangeFilterType(item.filterType)) {
        const hasRange = item.selectedValue.length > 0 && (item.selectedValue[0] || item.selectedValue[1]);
        return hasRange || item.includeNull;
      }
      return item.selectedValue.length > 0;
    });
  });

  /**
   * 全ての設定をリセットする
   */
  const resetAllSetting = () => {
    state.filterItems.forEach((item) => {
      item.selectedValue = [];
      if (item.includeNull !== undefined) {
        item.includeNull = false;
      }
    });
  };

  /**
   * フィルターアイテムを設定する
   * @param filterModalType - フィルターモーダルのタイプ
   */
  const setFilterItems = (filterModalType: FilterModalType) => {
    state.filterItems = simpleCopy(vm.useFilterItems(filterModalType));
  };

  /**
   * フィルターアイテムを設定する
   * @param items - フィルターアイテム
   */
  const updateFilterItems = (items?: FilterContentItem[]) => {
    if (items) {
      // 同じfilterTypeについて、selectedValueを上書きする
      items.forEach((item) => {
        const target = state.filterItems.find((filterItem) => filterItem.filterType === item.filterType);
        if (target) {
          target.selectedValue = item.selectedValue;
          if (item.includeNull !== undefined) {
            target.includeNull = item.includeNull;
          }
        }
      });
    }
  };

  return {
    state,
    $reset,
    appliedFilterContent,
    resetAllSetting,
    setFilterItems,
    updateFilterItems,
  };
});
